<script setup lang="ts">
import searchSvg from '@/assets/img/icon/search.svg';
import AppTextField from '@/components/base/AppTextField.vue';
import { useDebounceFn } from '@vueuse/core'; // Optional: You can write your own debounce function if not using VueUse

const props = defineProps<{
  placeholder?: string;
  debounce?: number; // Optional debounce delay in ms
}>();

const { placeholder = 'Search', debounce } = props;

// Bind to model
const search = defineModel<string>();

// Internal value to debounce input changes
const internalSearch = ref(search.value);

// Sync external model change - internal value
watch(search, (val) => {
  if (val !== internalSearch.value) internalSearch.value = val;
});

// Debounced update handler
const updateModel = debounce
  ? useDebounceFn((val: string) => {
      search.value = val;
    }, debounce)
  : (val: string) => {
      search.value = val;
    };

// Watch internal search input and apply debounced update
watch(internalSearch, (val) => {
  updateModel(val ?? '');
});
</script>

<template>
  <AppTextField v-model="internalSearch" class="search-field" density="compact" :placeholder="placeholder">
    <template #prepend-inner>
      <img :src="searchSvg" alt="search" />
    </template>
  </AppTextField>
</template>

<style lang="scss">
.search-field {
  .v-field {
    border-radius: 36px !important;
    padding-right: 6px;
    padding-left: 8px;
    background-color: rgb(var(--v-theme-neutral));
    border: none;

    .v-field__clearable i {
      font-size: 18px;
    }

    input {
      height: 32px;
      min-height: 32px;
    }
  }
}
</style>
